import React from 'react';
import { Table, Tag } from 'antd';
import { Link } from 'react-router-dom';
import { formatNumberWithCommas } from '../../../utils/numbers';
import styles from './styles/reports-table.module.scss';

function ReportsTransactionsTable({ rows, loading }) {
    const formatAmount = (amount) => {
        const formatted = formatNumberWithCommas(Math.abs(amount), true);
        return amount < 0 ? `-$${formatted}` : `$${formatted}`;
    };

    const getTypeTag = (type) => {
        // Map transaction types to display names
        const typeMap = {
            advance: 'Advance',
            settlement: 'Settlement',
            service_fee: 'Service Fee'
        };

        const displayName = typeMap[type] || type;

        return <Tag>{displayName}</Tag>;
    };

    const columns = [
        {
            title: 'Account',
            dataIndex: 'account_name',
            key: 'account_name',
            width: 200,
            render: (text) => <Link style={{ color: '#4285f4' }}>{text || 'Treasury'}</Link>
        },
        {
            title: 'User',
            dataIndex: 'user_name',
            key: 'user_name',
            width: 200,
            render: (text) => <p>{text || 'John Doe'}</p>
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            width: 150,
            render: (text) => <p>{formatAmount(text)}</p>
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            width: 150,
            render: (text) => getTypeTag(text)
        }
    ];

    return (
        <div className={styles.tableContainer}>
            <Table
                rowSelection={{
                    type: 'checkbox'
                }}
                columns={columns}
                dataSource={rows}
                pagination={{ pageSize: 15 }}
                loading={loading}
                scroll={{ x: 'max-content' }}
                className={styles.responsiveTable}
                rowKey={(record, index) => record.id || index}
            />
        </div>
    );
}

export default ReportsTransactionsTable;
